import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await api.post("/admin/login", { email, password });
            localStorage.setItem("em_admin_token", res.data.token);
            toast.success("Welcome back, operator.");
            navigate("/admin/dashboard");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Invalid credentials");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            data-testid="admin-login-page"
            className="min-h-screen bg-black text-white flex items-center justify-center px-6 grain"
        >
            <div className="w-full max-w-md">
                <Link
                    to="/"
                    className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground hover:text-white"
                >
                    ← Energy Matcher
                </Link>

                <div className="mt-12">
                    <Lock size={24} className="mb-6" />
                    <p className="label-mono">— Restricted</p>
                    <h1 className="font-display text-5xl md:text-6xl uppercase tracking-tight leading-none mt-4">
                        Admin
                        <br />
                        <span className="italic font-normal">Console.</span>
                    </h1>
                </div>

                <form onSubmit={onSubmit} className="mt-12 space-y-8" data-testid="admin-login-form">
                    <div>
                        <label className="label-mono block mb-2">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="admin-email"
                            className="w-full bg-transparent border-b border-white/30 focus:border-white py-3 outline-none font-sans"
                            placeholder="admin@energymatcher.com"
                        />
                    </div>
                    <div>
                        <label className="label-mono block mb-2">Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="admin-password"
                            className="w-full bg-transparent border-b border-white/30 focus:border-white py-3 outline-none font-sans"
                            placeholder="•••••••••••••"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-login-submit"
                        className="w-full bg-white text-black py-4 font-mono text-xs uppercase tracking-[0.25em] hover:bg-white/85 transition-colors disabled:opacity-60"
                    >
                        {loading ? "Authenticating…" : "Enter Console →"}
                    </button>
                </form>
            </div>
        </div>
    );
}
